import { SxProps, Theme } from "@mui/material/styles";

export function listRequestsWrapper(theme: Theme): SxProps<Theme> {
    return {
        zIndex: 1, 
        width: "100%", 
        borderRadius: "20px 20px 0 0", 
        my: "24px", 
        height: "calc(100vh - (84px * 1) - 2px - 48px)", 
        maxHeight: "calc(100vh - (84px * 1) - 2px - 48px)"
    };
}

export function listRequestsTitle(theme: Theme): SxProps<Theme> {
    return {
        margin: 0,
        paddingTop: "0.3em",
        paddingBottom: 0
    };
}

export function titleWrapper(theme: Theme): SxProps<Theme> {
    return {
        width: "100%",
        textAlign: "center",
        backgroundColor: "#ececec"
    };
}

export function departmentWrapper(theme: Theme): SxProps<Theme> {
    return {
        borderRadius: '10px',
        width: "100%",
        backgroundColor: "#ececec",
        display: "flex",
        justifyContent: "center",
    };
}


export function tableContainer(theme: Theme): SxProps<Theme> {
    return {
        overflow:"auto",
        maxHeight: `calc(100% - 47px - 0.3em)`,
        height: `calc(100% - 47px - 0.3em)`
    };
}


export function tableSearch(theme: Theme): SxProps<Theme> {
    return {
        display: "flex",
        alignContent: "center",
        justifyContent: "center",
        marginTop: "0.50rem",
        paddingBottom: "0.50rem"
    };
}


export function tableTextField(theme: Theme): SxProps<Theme> {
    return {
        maxHeight: '40px',
        backgroundColor:"white",
        borderRadius: "5px",
        minWidth: "150px",
        maxWidth: "170px",
    };
}

export function tableHeaderCell(theme: Theme): SxProps<Theme> {
    return {
        backgroundColor: "#ececec",
        minWidth: 150
    };
}

export function tableCell(theme: Theme): SxProps<Theme> {
    return {
        textAlign: "center"
    };
}

export function tableFooter(theme: Theme): SxProps<Theme> {
    return {
        backgroundColor: "#ececec"
    };
}

export function statusFilter(theme: Theme): SxProps<Theme> {
    return {
        maxWidth: "125px",
        width: "125px",
        backgroundColor:"white",
        borderRadius: "5px"
    };
}

export function organisationsFilter(theme: Theme): SxProps<Theme> {
    return {
        maxWidth: "170px",
        width: "150px",
        backgroundColor:"white",
        borderRadius: "5px"
    };
}

export function departmentFilter(theme: Theme): SxProps<Theme> {
    return {
        width: "150px",
        backgroundColor:"white",
        borderRadius: "5px",
        marginTop: '0.50rem',
        marginLeft: "16px",
    };
}

export function filterListButton(theme: Theme): SxProps<Theme> {
    return {
        // margin: '0 auto',
        borderRadius: '10px 10px 0 0',
        width: "90%"
    };
}

export function CollapseWrapper(theme: Theme): SxProps<Theme> {
    return {
        backgroundColor: "#ececec",
        ':last-child': {
            marginBottom: "0.50rem"
        }
    };
}

export function extraFilter(theme: Theme): SxProps<Theme> {
    return {
        border: '2px solid lightgray',
        borderRadius: '10px',
        backgroundColor: "#ececec",
        marginRight: '2rem',
        marginLeft: '2rem'
    }
}